import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    margin-bottom: var(--p-footer-nav-margin-bottom);
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  li {
    padding: 0;
  }

  a,
  button {
    color: var(--p-footer-link-color);
    text-decoration: var(--p-footer-link-text-decoration);
    display: block;
    display: flex;
    word-break: break-word;
    gap: 5px;
    align-items: baseline;
    font-size: 1rem;
    line-height: 1.3;
  }

  a svg {
    opacity: 0.7;
    min-width: 14px;
  }

  a:hover,
  button:hover {
    color: var(--p-footer-link-color-hover);
    text-decoration: var(--p-footer-link-text-decoration-hover);
  }
  button {
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    text-align: left;
    cursor: pointer;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: normal;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
  }
`;
